// extracted by mini-css-extract-plugin
module.exports = {"addCandTitle":"_3_iXoL0c","candidateContent":"gF0XRlMB","statusContent":"_3q4GgHiY","statusContainer":"_2MeQDOfg","lifecycleStatus":"_2xSYGoND","greenActive":"_2W9jfY5B","removeCandContent":"zslJgSw9","content":"_29HsGPxH"};
    if(module.hot) {
      // 1754515042473
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  